import { render, staticRenderFns } from "./AddProfileCompetenciesDialog.vue?vue&type=template&id=df5ee77c&scoped=true"
import script from "./AddProfileCompetenciesDialog.vue?vue&type=script&lang=js"
export * from "./AddProfileCompetenciesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5ee77c",
  null
  
)

export default component.exports